module.exports = __webpack_public_path__ + "src/assets/img/page9/06e61d5f4be21ae36b9bf2cdb2ea3989.png";